import { config } from "../../../../geopop/it/lib/config/production.js";
import { GeopopModuleLoader } from "../../../../geopop/it/pa/modularization/GeopopModuleLoader.js";

const al = new GeopopModuleLoader(window, config);
const gui = al.getGui();